import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import env from '../env';

const contentApi = createApi({
    reducerPath: 'content',
    baseQuery: fetchBaseQuery({
        baseUrl: env.baseUrl,
        prepareHeaders: (headers, { getState }) => {

            const token = getState().environment.token;

            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }

            return headers
        }
    }),
    tagTypes: ['Content'],
    endpoints(builder) {
        return {
            getContent: builder.query({
                query: (partition) => {
                    return {
                        url: `/content?partition=${partition}`,
                        method: 'GET',
                    };
                },
                providesTags: (result) => {
                    return result.map((content) => {
                        return { type: 'Content', id: content.partition }
                    });
                },
                transformResponse: (data) => {

                    data.forEach((c) => {
                        if (c.content) {
                            c.content = JSON.parse(c.content);
                        }
                    });

                    return data;
                },
            }),
            setContent: builder.mutation({
                query(data) {

                    data.content = JSON.stringify(data.content);

                    return {
                        url: `/content/` + data.key,
                        method: 'PUT',
                        body: data
                    }
                },
                invalidatesTags: (_result, _error, { partition }) => [{ type: 'Content', id: partition }],
            })
        };
    }
});

export const {
    useGetContentQuery, useSetContentMutation
} = contentApi;
export { contentApi };
